export const API_URL = "https://hub.inity.agency/wp-json";
